var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H18C17.175 0 16.5 0.675 16.5 1.5C16.5 2.325 17.175 3 18 3H22.5C24.975 3 27 5.025 27 7.5C27 9.975 24.975 12 22.5 12H18C17.175 12 16.5 12.675 16.5 13.5C16.5 14.325 17.175 15 18 15H22.5C26.64 15 30 11.64 30 7.5C30 3.36 26.64 0 22.5 0ZM9 7.5C9 8.325 9.675 9 10.5 9H19.5C20.325 9 21 8.325 21 7.5C21 6.675 20.325 6 19.5 6H10.5C9.675 6 9 6.675 9 7.5ZM12 12H7.5C5.025 12 3 9.975 3 7.5C3 5.025 5.025 3 7.5 3H12C12.825 3 13.5 2.325 13.5 1.5C13.5 0.675 12.825 0 12 0H7.5C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15H12C12.825 15 13.5 14.325 13.5 13.5C13.5 12.675 12.825 12 12 12Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.dab50b45993b0eac96a913d26b3868b0.svg";
export { ForwardRef as ReactComponent };